// Tailor (Tukang Jarit) badge — exact asset supplied by the user (red seal with sewing machine).
// Doubles as the "verified" badge for tailors, replacing the default blue check for them.

export const TailorBadge = ({ size = 18, className = "", title = "Tukang Jarit" }) => (
  <img
    src="/tailor-badge.png"
    alt="Tukang Jarit"
    title={title}
    data-testid="tailor-badge"
    style={{ width: size, height: size }}
    className={`inline-block shrink-0 align-middle ${className}`}
  />
);

export const JaritBadge = ({ show = true, size = 16, className = "" }) => {
  if (!show) return null;
  return <TailorBadge size={size} className={className} />;
};

export default JaritBadge;
